import { useContext } from "react";
import CartazFooterStyles from "./CartazFooterStyles";
import { BRAND_VIEW } from "../../../ToolBarMenuViews/Toolbar";
import WorkspaceContext from "../../../WorkspaceContext";
import {
  CANVAS_TARGET_CLASSNAME,
  FORMAT_DIMENSIONS,
  PANFLETO_DIM,
} from "../../EncarteConstants";
import { BrandLogo } from "../CanvasGeneralStyles";
import CartazProduct from "../CartazProduct";
import {
  CartazCanvasContainer,
  CartazFooter,
  CartazHeader,
  ProductWrapper,
} from "./CartazCanvas.styles";
export default function CartazCanvas({
  product,
  headerAndFooterStyles,
  index,
  isTargetCanvas = true,
}) {
  const { userBrand, setCurrentMenuView, styles, model, canvasScale } =
    useContext(WorkspaceContext);

  const cartazDimensions = FORMAT_DIMENSIONS[styles.format] || PANFLETO_DIM;

  return (
    <CartazCanvasContainer
      canvasScale={canvasScale}
      styles={styles}
      model={model}
      dimensions={cartazDimensions}
      className={isTargetCanvas && CANVAS_TARGET_CLASSNAME}
      footerRowHeight={cartazDimensions.footer}
    >
      <CartazHeader styles={styles} canvasScale={canvasScale}>
        {" "}
        <BrandLogo
          logo={userBrand.logoURLTmp}
          canvasScale={canvasScale}
          logoStyle={styles.logoStyle}
          position={{ bottom: 15, right: 10 }}
          size={100}
          headerStyles={headerAndFooterStyles}
          onClick={() => {
            setCurrentMenuView(BRAND_VIEW);
          }}
        />
      </CartazHeader>
      <ProductWrapper canvasScale={canvasScale}>
        <CartazProduct product={product} index={index} />
      </ProductWrapper>
      <CartazFooter model={model} canvasScale={canvasScale} styles={styles}>
        {headerAndFooterStyles && (
          <CartazFooterStyles
            canvasScale={canvasScale}
            headerAndFooterStyles={headerAndFooterStyles}
          />
        )}
      </CartazFooter>
    </CartazCanvasContainer>
  );
}
